import gql from "graphql-tag";

export default gql`
  mutation updateCarForSale(
    $id: Int!
    $mileage: Int
    $description: String
    $price: BigFloat
    $latitude: BigFloat
    $longitude: BigFloat
    $locationAddress: String
    $exteriorColor: String
    $interiorColor: String
    $titleStatus: String
    $imageLoc: JSON
    $videoLoc: JSON
  ) {
    updateCarsForSaleById(
      input: {
        id: $id,
        carsForSalePatch: {
          mileage: $mileage
          description: $description
          price: $price
          latitude: $latitude
          longitude: $longitude
          locationAddress: $locationAddress
          exteriorColor: $exteriorColor
          interiorColor: $interiorColor
          titleStatus: $titleStatus
          imageLoc: $imageLoc
          videoLoc: $videoLoc
        }
      }
    ) {
      clientMutationId
      carsForSale {
        id
        mileage
        description
        price
        latitude
        longitude
        locationAddress
        exteriorColor
        interiorColor
        titleStatus
        imageLoc
        videoLoc
        updatedAt
      }
    }
  }
`;
